// RecordEditNextOfKin - MODULE
// ***********************************************************************************************************************
import { Grid, TextField } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { IRecordEditItem } from "../../../models/record/recordEditItem";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";

//RecordEditNextOfKin
export interface IRecordEditNextOfKinProp {
    record: IRecordEditItem;
    nextOfKinFirstName: string;
    nextOfKinLastName: string;
    nextOfKinPostalAddress: string;
    nextOfKinPostalCode: string;
    nextOfKinCity: string;
    nextOfKinPhone: string;
    nextOfKinEmail: string;
    onChange: (name: string, value: string) => void;
}

export class RecordEditNextOfKin extends React.Component<IRecordEditNextOfKinProp, {}> {
    handleChange = (event) => {
        const target = event.target;
        this.props.onChange(target.name, target.value);
    };

    render() {
        const props = this.props;
        const record = props.record;
        if (!record) return null;
        return (
            <GridRow>
                <Grid item sm={12} xl={6}>
                    <GridRow>
                        <Grid item xs>
                            <FormField title={Translations.FirstName} margin={0}>
                                <TextField type="text" name="nextOfKinFirstName" title={Translations.FirstName} inputProps={{ maxLength: 50 }} value={props.nextOfKinFirstName} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                        <Grid item xs>
                            <FormField title={Translations.LastName} margin={0}>
                                <TextField type="text" name="nextOfKinLastName" title={Translations.LastName} inputProps={{ maxLength: 50 }} value={props.nextOfKinLastName} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item xs>
                            <FormField title={Translations.PostalAddress}>
                                <TextField type="text" name="nextOfKinPostalAddress" title={Translations.PostalAddress} inputProps={{ maxLength: 50 }} disabled={false} value={props.nextOfKinPostalAddress} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item md={4}>
                            <FormField title={Translations.PostalCode}>
                                <TextField type="text" name="nextOfKinPostalCode" title={Translations.PostalCode} inputProps={{ maxLength: 10 }} disabled={false} value={props.nextOfKinPostalCode} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                        <Grid item md={8}>
                            <FormField title={Translations.City}>
                                <TextField type="text" name="nextOfKinCity" title={Translations.City} inputProps={{ maxLength: 50 }} disabled={false} value={props.nextOfKinCity} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item sm={4}>
                            <FormField title={Translations.Phone}>
                                <TextField type="text" name="nextOfKinPhone" title={Translations.Phone} inputProps={{ maxLength: 50 }} disabled={false} value={props.nextOfKinPhone} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                        <Grid item sm={8}>
                            <FormField title={Translations.EmailAddress}>
                                <TextField type="text" name="nextOfKinEmail" title={Translations.EmailAddress} inputProps={{ maxLength: 50 }} disabled={false} value={props.nextOfKinEmail} onChange={this.handleChange} />
                            </FormField>
                        </Grid>
                    </GridRow>
                </Grid>
            </GridRow>
        );
    }
}